import React from 'react';
import styled from 'styled-components';
import Typography from '../../common/Typography';
import { IonIcon } from '@ionic/react';
import { checkmarkCircle } from 'ionicons/icons';

const Radio = styled.input`
  opacity: 0.01;
  z-index: 100;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
  }
`;
const Content = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px solid #ccc;
  cursor: pointer;
  z-index: 90;
  border-radius: 4px;
`;
const OptionLabel = styled.label`
  font-weight: bold;
  font-size: 20px;
  // color: var(--ion-color-primary);
`;

const DetailsContainer = styled.div`
  display: flex;

  // align-items: center;
  flex-direction: column;

  padding: 16px;
`;
const OptionContainer = styled('li')`
  float: left;
  width: 100%;
  height: 200px;
  position: relative;
  cursor: pointer;
  margin: 16px 0;

  display: flex;
  justify-content: center;

  list-style-type: none;

  & ${Radio}:disabled + ${Content} {
    opacity: 0.5;
  }
  & ${Radio}:checked + ${Content} {
    // background-color: var(--accent-color6);
    // background-color: var(--color-primary-light3);
    background-color: #d7ccec33;
  }
  &:hover {
    & ${Content} {
      box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
      // background-color: var(--ion-color-light-shade);
      background-color: #d7ccec11;
    }
  }
`;

const OptionDetails = styled(Typography)`
  margin-top: 16px;
  // color: var(--ion-color-secondary);
`;

const CheckedIcon = styled(IonIcon)`
  position: absolute;
  bottom: -16px;
  // right: -16px;
  left: calc(50% - 16px);
  color: var(--accent-color4);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: white;
`;
const IconContainer = styled.div<{ $iconAlignment?: 'top' | 'center' }>`
  display: flex;
  justify-content: ${(props) =>
    props.$iconAlignment === 'top' ? 'flex-start' : 'center'};
  align-items: center;
  max-width: 100px;
  padding: 16px;
`;

const OptionList = styled.ul`
  list-style-type: none;
  margin: 25px 0 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const Subtext = styled(Typography)`
  margin-top: 8px;
  color: var(--ion-color-secondary);
  font-size: 12px;
`;

interface OptionProps extends React.LiHTMLAttributes<HTMLLIElement> {
  inputProps: React.InputHTMLAttributes<HTMLInputElement>;
  icon?: React.ReactNode;
  label: string;
  details: string | React.ReactNode;
  iconAlignment?: 'top' | 'center';
  subtext?: string;
}

export const Option: React.FC<OptionProps> = ({
  label,
  icon,
  details,
  inputProps,
  iconAlignment = 'center',
  subtext,
  ...props
}) => {
  return (
    <OptionContainer {...props}>
      <Radio type="radio" {...inputProps} />
      <Content>
        {icon && (
          <IconContainer $iconAlignment={iconAlignment}>{icon}</IconContainer>
        )}
        <DetailsContainer>
          <OptionLabel htmlFor={props.id}>{label}</OptionLabel>

          <OptionDetails>{details}</OptionDetails>

          {subtext && (
            <Subtext variant="body2" color="secondary">
              {subtext}
            </Subtext>
          )}

          {inputProps.checked && <CheckedIcon icon={checkmarkCircle} />}
        </DetailsContainer>
      </Content>
    </OptionContainer>
  );
};

export default OptionList;
